export const allData = {
    "warehouseNotDelivered":{
        "data":[
            {
                "shopList":[
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":64,
                        "CP_C_SHOP_ECODE":"2021014",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"2021014",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":55,
                        "CP_C_SHOP_ECODE":"2021",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":74,
                        "CP_C_SHOP_ECODE":"ABC",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺zxs",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":63,
                        "CP_C_SHOP_ECODE":"AAT001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺-自动化专用（勿动）",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":40,
                        "CP_C_SHOP_ECODE":"gjdp",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"古古店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":45,
                        "CP_C_SHOP_ECODE":"1 00 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":76,
                        "CP_C_SHOP_ECODE":"cc",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"cc",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":67,
                        "CP_C_SHOP_ECODE":"aaaaaaaa",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":77,
                        "CP_C_SHOP_ECODE":"11",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"SK-II官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":72,
                        "CP_C_SHOP_ECODE":"BM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"布美",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":21,
                        "CP_C_SHOP_ECODE":"123",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"沙宣官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":39,
                        "CP_C_SHOP_ECODE":"aabb",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号278",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":79,
                        "CP_C_SHOP_ECODE":"POP-DB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP-抖音宝洁小铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":80,
                        "CP_C_SHOP_ECODE":"lyh平台店铺",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"lyh平台店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":59,
                        "CP_C_SHOP_ECODE":"YZ-EP1",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":32,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":51,
                        "CP_C_SHOP_ECODE":"110",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":82,
                        "CP_C_SHOP_ECODE":"sss0001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁生活馆",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":69,
                        "CP_C_SHOP_ECODE":"a00001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":52,
                        "CP_C_SHOP_ECODE":"221",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":68,
                        "CP_C_SHOP_ECODE":"1005",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":44,
                        "CP_C_SHOP_ECODE":"fyt",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"哈哈哈哈哈",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":83,
                        "CP_C_SHOP_ECODE":"2323",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":56,
                        "CP_C_SHOP_ECODE":"YZ-EP",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"EAZYPEY有赞",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":43,
                        "CP_C_SHOP_ECODE":"XHS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小红书宝洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":48,
                        "CP_C_SHOP_ECODE":"qqqqq",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"业务讲解店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":70,
                        "CP_C_SHOP_ECODE":"hao12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hao测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":73,
                        "CP_C_SHOP_ECODE":"AAA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":2,
                        "CP_C_SHOP_ECODE":"TM-PG",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":75,
                        "CP_C_SHOP_ECODE":"BB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"xxmtest",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":84,
                        "CP_C_SHOP_ECODE":"CS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":60,
                        "CP_C_SHOP_ECODE":"1002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"店铺测试001",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":87,
                        "CP_C_SHOP_ECODE":"AX001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"翱象联调测试账号6",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":50,
                        "CP_C_SHOP_ECODE":"878888887WUWUUWU",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"大概",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":66,
                        "CP_C_SHOP_ECODE":"1 004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺3小小王测试店铺3小王测试店铺3小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":49,
                        "CP_C_SHOP_ECODE":"ggggggg",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"fdgrgre",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":19,
                        "CP_C_SHOP_ECODE":"11 1122啊啊啊",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":46,
                        "CP_C_SHOP_ECODE":"111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试hold单权限",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":62,
                        "CP_C_SHOP_ECODE":"1111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试11111111",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":23,
                        "CP_C_SHOP_ECODE":"12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aussie旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":86,
                        "CP_C_SHOP_ECODE":"123131",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"张测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":38,
                        "CP_C_SHOP_ECODE":"XXKH",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"线下客户",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":22,
                        "CP_C_SHOP_ECODE":"1234",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁集市自营店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":41,
                        "CP_C_SHOP_ECODE":"XHS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP小红书-植感哲学",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":81,
                        "CP_C_SHOP_ECODE":"cl10101",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁洗护清洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":61,
                        "CP_C_SHOP_ECODE":"100 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺002",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":71,
                        "CP_C_SHOP_ECODE":"you12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"haoyouzan",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":31,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"olay官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":35,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"HerbalEssences官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":36,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"欧乐b一商益洁专卖店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":88,
                        "CP_C_SHOP_ECODE":"111212",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"11",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":78,
                        "CP_C_SHOP_ECODE":"JDMARNA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"MARNA京东旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":24,
                        "CP_C_SHOP_ECODE":"1234567",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hairrecipe官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":85,
                        "CP_C_SHOP_ECODE":"CS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":47,
                        "CP_C_SHOP_ECODE":"11222",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hold单测试11.12",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":37,
                        "CP_C_SHOP_ECODE":"TM-VS",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"吉列官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":65,
                        "CP_C_SHOP_ECODE":"10 0 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":20,
                        "CP_C_SHOP_ECODE":"bbs001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"帮宝适官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":33,
                        "CP_C_SHOP_ECODE":"1004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号177",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":42,
                        "CP_C_SHOP_ECODE":"YZ001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁旗舰店-微店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    }
                ]
            }
        ],
        "count":0.0000,
        "title":"仓库未发货",
        "key":"WAREHOUSE_NOT_DELIVERED"
    },
    "refundOrder":{
        "data":[
            {
                "shopList":[
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":31,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"olay官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":121.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":42,
                        "CP_C_SHOP_ECODE":"YZ001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁旗舰店-微店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":61,
                        "CP_C_SHOP_ECODE":"100 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺002",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":49,
                        "CP_C_SHOP_ECODE":"ggggggg",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"fdgrgre",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":59,
                        "CP_C_SHOP_ECODE":"YZ-EP1",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":85,
                        "CP_C_SHOP_ECODE":"CS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":37,
                        "CP_C_SHOP_ECODE":"TM-VS",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"吉列官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":62,
                        "CP_C_SHOP_ECODE":"1111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试11111111",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":51,
                        "CP_C_SHOP_ECODE":"110",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":88,
                        "CP_C_SHOP_ECODE":"111212",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"11",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":83,
                        "CP_C_SHOP_ECODE":"2323",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":63,
                        "CP_C_SHOP_ECODE":"AAT001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺-自动化专用（勿动）",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":69,
                        "CP_C_SHOP_ECODE":"a00001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":67,
                        "CP_C_SHOP_ECODE":"aaaaaaaa",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":72,
                        "CP_C_SHOP_ECODE":"BM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"布美",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":39,
                        "CP_C_SHOP_ECODE":"aabb",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号278",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":38,
                        "CP_C_SHOP_ECODE":"XXKH",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"线下客户",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":40,
                        "CP_C_SHOP_ECODE":"gjdp",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"古古店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":23,
                        "CP_C_SHOP_ECODE":"12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aussie旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":22,
                        "CP_C_SHOP_ECODE":"1234",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁集市自营店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":75,
                        "CP_C_SHOP_ECODE":"BB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"xxmtest",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":66,
                        "CP_C_SHOP_ECODE":"1 004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺3小小王测试店铺3小王测试店铺3小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":32,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":36,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"欧乐b一商益洁专卖店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":20,
                        "CP_C_SHOP_ECODE":"bbs001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"帮宝适官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":71,
                        "CP_C_SHOP_ECODE":"you12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"haoyouzan",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":77,
                        "CP_C_SHOP_ECODE":"11",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"SK-II官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":86,
                        "CP_C_SHOP_ECODE":"123131",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"张测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":2,
                        "CP_C_SHOP_ECODE":"TM-PG",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":79,
                        "CP_C_SHOP_ECODE":"POP-DB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP-抖音宝洁小铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":41,
                        "CP_C_SHOP_ECODE":"XHS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP小红书-植感哲学",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":33,
                        "CP_C_SHOP_ECODE":"1004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号177",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":52,
                        "CP_C_SHOP_ECODE":"221",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":56,
                        "CP_C_SHOP_ECODE":"YZ-EP",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"EAZYPEY有赞",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":81,
                        "CP_C_SHOP_ECODE":"cl10101",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁洗护清洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":45,
                        "CP_C_SHOP_ECODE":"1 00 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":82,
                        "CP_C_SHOP_ECODE":"sss0001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁生活馆",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":46,
                        "CP_C_SHOP_ECODE":"111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试hold单权限",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":64,
                        "CP_C_SHOP_ECODE":"2021014",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"2021014",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":35,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"HerbalEssences官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":50,
                        "CP_C_SHOP_ECODE":"878888887WUWUUWU",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"大概",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":74,
                        "CP_C_SHOP_ECODE":"ABC",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺zxs",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":80,
                        "CP_C_SHOP_ECODE":"lyh平台店铺",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"lyh平台店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":87,
                        "CP_C_SHOP_ECODE":"AX001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"翱象联调测试账号6",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":73,
                        "CP_C_SHOP_ECODE":"AAA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":55,
                        "CP_C_SHOP_ECODE":"2021",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":24,
                        "CP_C_SHOP_ECODE":"1234567",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hairrecipe官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":43,
                        "CP_C_SHOP_ECODE":"XHS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小红书宝洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":84,
                        "CP_C_SHOP_ECODE":"CS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":70,
                        "CP_C_SHOP_ECODE":"hao12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hao测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":65,
                        "CP_C_SHOP_ECODE":"10 0 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":60,
                        "CP_C_SHOP_ECODE":"1002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"店铺测试001",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":78,
                        "CP_C_SHOP_ECODE":"JDMARNA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"MARNA京东旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":47,
                        "CP_C_SHOP_ECODE":"11222",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hold单测试11.12",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":76,
                        "CP_C_SHOP_ECODE":"cc",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"cc",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":44,
                        "CP_C_SHOP_ECODE":"fyt",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"哈哈哈哈哈",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":48,
                        "CP_C_SHOP_ECODE":"qqqqq",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"业务讲解店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":19,
                        "CP_C_SHOP_ECODE":"11 1122啊啊啊",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":68,
                        "CP_C_SHOP_ECODE":"1005",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"未完结退款单",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":21,
                        "CP_C_SHOP_ECODE":"123",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"沙宣官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"未发货仅退款",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    }
                ],
                "count":121.0000,
                "title":"未发货仅退款",
                "key":"REFUND_BEFORE_DELIVERY"
            }
        ],
        "count":121.0000,
        "title":"未完结退款单",
        "key":"REFUND_ORDER"
    },
    "currentDate":"2022-03-24 15:32:54",
    "platformNotDelivered":{
        "data":[
            {
                "shopList":[
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":68,
                        "CP_C_SHOP_ECODE":"1005",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":41,
                        "CP_C_SHOP_ECODE":"XHS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP小红书-植感哲学",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":23,
                        "CP_C_SHOP_ECODE":"12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aussie旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":66,
                        "CP_C_SHOP_ECODE":"1 004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺3小小王测试店铺3小王测试店铺3小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":38,
                        "CP_C_SHOP_ECODE":"XXKH",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"线下客户",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":75,
                        "CP_C_SHOP_ECODE":"BB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"xxmtest",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":40,
                        "CP_C_SHOP_ECODE":"gjdp",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"古古店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":83,
                        "CP_C_SHOP_ECODE":"2323",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":43,
                        "CP_C_SHOP_ECODE":"XHS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小红书宝洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":31,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"olay官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":20,
                        "CP_C_SHOP_ECODE":"bbs001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"帮宝适官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":73,
                        "CP_C_SHOP_ECODE":"AAA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":22,
                        "CP_C_SHOP_ECODE":"1234",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁集市自营店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":45,
                        "CP_C_SHOP_ECODE":"1 00 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":50,
                        "CP_C_SHOP_ECODE":"878888887WUWUUWU",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"大概",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":70,
                        "CP_C_SHOP_ECODE":"hao12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hao测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":51,
                        "CP_C_SHOP_ECODE":"110",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":62,
                        "CP_C_SHOP_ECODE":"1111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试11111111",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":42,
                        "CP_C_SHOP_ECODE":"YZ001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁旗舰店-微店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":64,
                        "CP_C_SHOP_ECODE":"2021014",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"2021014",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":19,
                        "CP_C_SHOP_ECODE":"11 1122啊啊啊",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":24,
                        "CP_C_SHOP_ECODE":"1234567",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hairrecipe官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":2,
                        "CP_C_SHOP_ECODE":"TM-PG",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":78,
                        "CP_C_SHOP_ECODE":"JDMARNA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"MARNA京东旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":63,
                        "CP_C_SHOP_ECODE":"AAT001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺-自动化专用（勿动）",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":59,
                        "CP_C_SHOP_ECODE":"YZ-EP1",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":80,
                        "CP_C_SHOP_ECODE":"lyh平台店铺",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"lyh平台店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":33,
                        "CP_C_SHOP_ECODE":"1004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号177",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":85,
                        "CP_C_SHOP_ECODE":"CS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":55,
                        "CP_C_SHOP_ECODE":"2021",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":74,
                        "CP_C_SHOP_ECODE":"ABC",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺zxs",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":79,
                        "CP_C_SHOP_ECODE":"POP-DB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP-抖音宝洁小铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":39,
                        "CP_C_SHOP_ECODE":"aabb",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号278",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":36,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"欧乐b一商益洁专卖店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":21,
                        "CP_C_SHOP_ECODE":"123",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"沙宣官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":77,
                        "CP_C_SHOP_ECODE":"11",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"SK-II官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":47,
                        "CP_C_SHOP_ECODE":"11222",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hold单测试11.12",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":35,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"HerbalEssences官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":84,
                        "CP_C_SHOP_ECODE":"CS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":48,
                        "CP_C_SHOP_ECODE":"qqqqq",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"业务讲解店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":56,
                        "CP_C_SHOP_ECODE":"YZ-EP",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"EAZYPEY有赞",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":49,
                        "CP_C_SHOP_ECODE":"ggggggg",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"fdgrgre",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":46,
                        "CP_C_SHOP_ECODE":"111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试hold单权限",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":71,
                        "CP_C_SHOP_ECODE":"you12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"haoyouzan",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":72,
                        "CP_C_SHOP_ECODE":"BM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"布美",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":37,
                        "CP_C_SHOP_ECODE":"TM-VS",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"吉列官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":65,
                        "CP_C_SHOP_ECODE":"10 0 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":69,
                        "CP_C_SHOP_ECODE":"a00001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":60,
                        "CP_C_SHOP_ECODE":"1002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"店铺测试001",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":52,
                        "CP_C_SHOP_ECODE":"221",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":61,
                        "CP_C_SHOP_ECODE":"100 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺002",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":88,
                        "CP_C_SHOP_ECODE":"111212",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"11",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":81,
                        "CP_C_SHOP_ECODE":"cl10101",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁洗护清洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":32,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":82,
                        "CP_C_SHOP_ECODE":"sss0001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁生活馆",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":44,
                        "CP_C_SHOP_ECODE":"fyt",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"哈哈哈哈哈",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":87,
                        "CP_C_SHOP_ECODE":"AX001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"翱象联调测试账号6",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":76,
                        "CP_C_SHOP_ECODE":"cc",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"cc",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":86,
                        "CP_C_SHOP_ECODE":"123131",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"张测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货平台未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":67,
                        "CP_C_SHOP_ECODE":"aaaaaaaa",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    }
                ]
            }
        ],
        "count":0.0000,
        "title":"仓库发货平台未发货",
        "key":"PLATFORM_NOT_DELIVERED"
    },
    "refundSuccessful":{
        "data":[
            {
                "shopList":[
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":24,
                        "CP_C_SHOP_ECODE":"1234567",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hairrecipe官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":37,
                        "CP_C_SHOP_ECODE":"TM-VS",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"吉列官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":48,
                        "CP_C_SHOP_ECODE":"qqqqq",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"业务讲解店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":40,
                        "CP_C_SHOP_ECODE":"gjdp",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"古古店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":76,
                        "CP_C_SHOP_ECODE":"cc",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"cc",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":21,
                        "CP_C_SHOP_ECODE":"123",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"沙宣官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":61,
                        "CP_C_SHOP_ECODE":"100 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺002",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":47,
                        "CP_C_SHOP_ECODE":"11222",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hold单测试11.12",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":44,
                        "CP_C_SHOP_ECODE":"fyt",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"哈哈哈哈哈",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":56,
                        "CP_C_SHOP_ECODE":"YZ-EP",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"EAZYPEY有赞",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":31,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"olay官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":19,
                        "CP_C_SHOP_ECODE":"11 1122啊啊啊",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":46,
                        "CP_C_SHOP_ECODE":"111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试hold单权限",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":42,
                        "CP_C_SHOP_ECODE":"YZ001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁旗舰店-微店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":55,
                        "CP_C_SHOP_ECODE":"2021",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":79,
                        "CP_C_SHOP_ECODE":"POP-DB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP-抖音宝洁小铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":68,
                        "CP_C_SHOP_ECODE":"1005",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":62,
                        "CP_C_SHOP_ECODE":"1111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试11111111",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":80,
                        "CP_C_SHOP_ECODE":"lyh平台店铺",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"lyh平台店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":84,
                        "CP_C_SHOP_ECODE":"CS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":59,
                        "CP_C_SHOP_ECODE":"YZ-EP1",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":87,
                        "CP_C_SHOP_ECODE":"AX001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"翱象联调测试账号6",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":65,
                        "CP_C_SHOP_ECODE":"10 0 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":81,
                        "CP_C_SHOP_ECODE":"cl10101",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁洗护清洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":64,
                        "CP_C_SHOP_ECODE":"2021014",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"2021014",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":49,
                        "CP_C_SHOP_ECODE":"ggggggg",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"fdgrgre",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":32,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":35,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"HerbalEssences官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":41,
                        "CP_C_SHOP_ECODE":"XHS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP小红书-植感哲学",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":69,
                        "CP_C_SHOP_ECODE":"a00001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":20,
                        "CP_C_SHOP_ECODE":"bbs001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"帮宝适官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":83,
                        "CP_C_SHOP_ECODE":"2323",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":82,
                        "CP_C_SHOP_ECODE":"sss0001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁生活馆",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":71,
                        "CP_C_SHOP_ECODE":"you12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"haoyouzan",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":50,
                        "CP_C_SHOP_ECODE":"878888887WUWUUWU",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"大概",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":66,
                        "CP_C_SHOP_ECODE":"1 004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺3小小王测试店铺3小王测试店铺3小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":74,
                        "CP_C_SHOP_ECODE":"ABC",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺zxs",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":73,
                        "CP_C_SHOP_ECODE":"AAA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":72,
                        "CP_C_SHOP_ECODE":"BM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"布美",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":52,
                        "CP_C_SHOP_ECODE":"221",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":88,
                        "CP_C_SHOP_ECODE":"111212",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"11",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":45,
                        "CP_C_SHOP_ECODE":"1 00 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":67,
                        "CP_C_SHOP_ECODE":"aaaaaaaa",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":39,
                        "CP_C_SHOP_ECODE":"aabb",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号278",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":60,
                        "CP_C_SHOP_ECODE":"1002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"店铺测试001",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":2,
                        "CP_C_SHOP_ECODE":"TM-PG",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":86,
                        "CP_C_SHOP_ECODE":"123131",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"张测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":51,
                        "CP_C_SHOP_ECODE":"110",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":78,
                        "CP_C_SHOP_ECODE":"JDMARNA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"MARNA京东旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":75,
                        "CP_C_SHOP_ECODE":"BB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"xxmtest",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":85,
                        "CP_C_SHOP_ECODE":"CS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":33,
                        "CP_C_SHOP_ECODE":"1004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号177",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":70,
                        "CP_C_SHOP_ECODE":"hao12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hao测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":43,
                        "CP_C_SHOP_ECODE":"XHS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小红书宝洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":22,
                        "CP_C_SHOP_ECODE":"1234",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁集市自营店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":63,
                        "CP_C_SHOP_ECODE":"AAT001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺-自动化专用（勿动）",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":36,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"欧乐b一商益洁专卖店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":23,
                        "CP_C_SHOP_ECODE":"12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aussie旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":77,
                        "CP_C_SHOP_ECODE":"11",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"SK-II官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"仓库发货退款成功",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":38,
                        "CP_C_SHOP_ECODE":"XXKH",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"线下客户",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    }
                ]
            }
        ],
        "count":0.0000,
        "title":"仓库发货退款成功",
        "key":"REFUND_SUCCESSFUL"
    },
    "warehouse12hNotDelivered":{
        "data":[
            {
                "shopList":[
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":31,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"olay官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":2.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":45,
                        "CP_C_SHOP_ECODE":"1 00 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":5.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":64,
                        "CP_C_SHOP_ECODE":"2021014",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"2021014",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":86,
                        "CP_C_SHOP_ECODE":"123131",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"张测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":60,
                        "CP_C_SHOP_ECODE":"1002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"店铺测试001",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":50,
                        "CP_C_SHOP_ECODE":"878888887WUWUUWU",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"大概",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":76,
                        "CP_C_SHOP_ECODE":"cc",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"cc",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":69,
                        "CP_C_SHOP_ECODE":"a00001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":79,
                        "CP_C_SHOP_ECODE":"POP-DB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP-抖音宝洁小铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":46,
                        "CP_C_SHOP_ECODE":"111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试hold单权限",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":23,
                        "CP_C_SHOP_ECODE":"12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aussie旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":68,
                        "CP_C_SHOP_ECODE":"1005",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":20,
                        "CP_C_SHOP_ECODE":"bbs001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"帮宝适官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":71,
                        "CP_C_SHOP_ECODE":"you12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"haoyouzan",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":59,
                        "CP_C_SHOP_ECODE":"YZ-EP1",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":62,
                        "CP_C_SHOP_ECODE":"1111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试11111111",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":38,
                        "CP_C_SHOP_ECODE":"XXKH",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"线下客户",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":47,
                        "CP_C_SHOP_ECODE":"11222",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hold单测试11.12",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":24,
                        "CP_C_SHOP_ECODE":"1234567",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hairrecipe官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":82,
                        "CP_C_SHOP_ECODE":"sss0001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁生活馆",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":75,
                        "CP_C_SHOP_ECODE":"BB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"xxmtest",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":88,
                        "CP_C_SHOP_ECODE":"111212",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"11",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":85,
                        "CP_C_SHOP_ECODE":"CS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":35,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"HerbalEssences官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":78,
                        "CP_C_SHOP_ECODE":"JDMARNA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"MARNA京东旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":63,
                        "CP_C_SHOP_ECODE":"AAT001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺-自动化专用（勿动）",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":66,
                        "CP_C_SHOP_ECODE":"1 004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺3小小王测试店铺3小王测试店铺3小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":72,
                        "CP_C_SHOP_ECODE":"BM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"布美",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":32,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":40,
                        "CP_C_SHOP_ECODE":"gjdp",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"古古店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":65,
                        "CP_C_SHOP_ECODE":"10 0 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":52,
                        "CP_C_SHOP_ECODE":"221",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":36,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"欧乐b一商益洁专卖店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":33,
                        "CP_C_SHOP_ECODE":"1004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号177",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":48,
                        "CP_C_SHOP_ECODE":"qqqqq",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"业务讲解店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":81,
                        "CP_C_SHOP_ECODE":"cl10101",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁洗护清洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":49,
                        "CP_C_SHOP_ECODE":"ggggggg",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"fdgrgre",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":41,
                        "CP_C_SHOP_ECODE":"XHS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP小红书-植感哲学",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":51,
                        "CP_C_SHOP_ECODE":"110",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":39,
                        "CP_C_SHOP_ECODE":"aabb",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号278",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":80,
                        "CP_C_SHOP_ECODE":"lyh平台店铺",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"lyh平台店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":77,
                        "CP_C_SHOP_ECODE":"11",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"SK-II官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":2,
                        "CP_C_SHOP_ECODE":"TM-PG",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":67,
                        "CP_C_SHOP_ECODE":"aaaaaaaa",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":19,
                        "CP_C_SHOP_ECODE":"11 1122啊啊啊",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":55,
                        "CP_C_SHOP_ECODE":"2021",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":21,
                        "CP_C_SHOP_ECODE":"123",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"沙宣官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":37,
                        "CP_C_SHOP_ECODE":"TM-VS",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"吉列官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":70,
                        "CP_C_SHOP_ECODE":"hao12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hao测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":43,
                        "CP_C_SHOP_ECODE":"XHS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小红书宝洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":44,
                        "CP_C_SHOP_ECODE":"fyt",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"哈哈哈哈哈",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":61,
                        "CP_C_SHOP_ECODE":"100 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺002",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":22,
                        "CP_C_SHOP_ECODE":"1234",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁集市自营店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":84,
                        "CP_C_SHOP_ECODE":"CS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":42,
                        "CP_C_SHOP_ECODE":"YZ001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁旗舰店-微店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":83,
                        "CP_C_SHOP_ECODE":"2323",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":73,
                        "CP_C_SHOP_ECODE":"AAA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":56,
                        "CP_C_SHOP_ECODE":"YZ-EP",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"EAZYPEY有赞",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":87,
                        "CP_C_SHOP_ECODE":"AX001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"翱象联调测试账号6",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"超12小时仓库未发货",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":74,
                        "CP_C_SHOP_ECODE":"ABC",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺zxs",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    }
                ]
            }
        ],
        "count":7.0000,
        "title":"超12小时仓库未发货",
        "key":"WAREHOUSE_12h_NOT_DELIVERED"
    },
    "interceptionOrder":{
        "data":[
            {
                "shopList":[
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":72,
                        "CP_C_SHOP_ECODE":"BM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"布美",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":36,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"欧乐b一商益洁专卖店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":40,
                        "CP_C_SHOP_ECODE":"gjdp",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"古古店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":82,
                        "CP_C_SHOP_ECODE":"sss0001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁生活馆",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":20,
                        "CP_C_SHOP_ECODE":"bbs001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"帮宝适官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":19,
                        "CP_C_SHOP_ECODE":"11 1122啊啊啊",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":51,
                        "CP_C_SHOP_ECODE":"110",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":31,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"olay官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":47,
                        "CP_C_SHOP_ECODE":"11222",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hold单测试11.12",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":43,
                        "CP_C_SHOP_ECODE":"XHS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小红书宝洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":33,
                        "CP_C_SHOP_ECODE":"1004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号177",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":63,
                        "CP_C_SHOP_ECODE":"AAT001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺-自动化专用（勿动）",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":76,
                        "CP_C_SHOP_ECODE":"cc",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"cc",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":61,
                        "CP_C_SHOP_ECODE":"100 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺002",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":50,
                        "CP_C_SHOP_ECODE":"878888887WUWUUWU",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"大概",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":74,
                        "CP_C_SHOP_ECODE":"ABC",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺zxs",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":73,
                        "CP_C_SHOP_ECODE":"AAA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":32,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":85,
                        "CP_C_SHOP_ECODE":"CS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":21,
                        "CP_C_SHOP_ECODE":"123",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"沙宣官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":66,
                        "CP_C_SHOP_ECODE":"1 004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺3小小王测试店铺3小王测试店铺3小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":67,
                        "CP_C_SHOP_ECODE":"aaaaaaaa",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":39,
                        "CP_C_SHOP_ECODE":"aabb",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号278",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":22,
                        "CP_C_SHOP_ECODE":"1234",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁集市自营店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":38,
                        "CP_C_SHOP_ECODE":"XXKH",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"线下客户",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":49,
                        "CP_C_SHOP_ECODE":"ggggggg",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"fdgrgre",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":71,
                        "CP_C_SHOP_ECODE":"you12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"haoyouzan",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":64,
                        "CP_C_SHOP_ECODE":"2021014",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"2021014",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":55,
                        "CP_C_SHOP_ECODE":"2021",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":56,
                        "CP_C_SHOP_ECODE":"YZ-EP",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"EAZYPEY有赞",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":23,
                        "CP_C_SHOP_ECODE":"12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aussie旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":62,
                        "CP_C_SHOP_ECODE":"1111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试11111111",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":65,
                        "CP_C_SHOP_ECODE":"10 0 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":75,
                        "CP_C_SHOP_ECODE":"BB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"xxmtest",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":24,
                        "CP_C_SHOP_ECODE":"1234567",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hairrecipe官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":86,
                        "CP_C_SHOP_ECODE":"123131",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"张测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":45,
                        "CP_C_SHOP_ECODE":"1 00 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":88,
                        "CP_C_SHOP_ECODE":"111212",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"11",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":59,
                        "CP_C_SHOP_ECODE":"YZ-EP1",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":81,
                        "CP_C_SHOP_ECODE":"cl10101",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁洗护清洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":44,
                        "CP_C_SHOP_ECODE":"fyt",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"哈哈哈哈哈",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":80,
                        "CP_C_SHOP_ECODE":"lyh平台店铺",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"lyh平台店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":78,
                        "CP_C_SHOP_ECODE":"JDMARNA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"MARNA京东旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":77,
                        "CP_C_SHOP_ECODE":"11",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"SK-II官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":46,
                        "CP_C_SHOP_ECODE":"111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试hold单权限",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":48,
                        "CP_C_SHOP_ECODE":"qqqqq",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"业务讲解店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":35,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"HerbalEssences官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":79,
                        "CP_C_SHOP_ECODE":"POP-DB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP-抖音宝洁小铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":41,
                        "CP_C_SHOP_ECODE":"XHS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP小红书-植感哲学",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":83,
                        "CP_C_SHOP_ECODE":"2323",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":52,
                        "CP_C_SHOP_ECODE":"221",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":60,
                        "CP_C_SHOP_ECODE":"1002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"店铺测试001",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":68,
                        "CP_C_SHOP_ECODE":"1005",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":42,
                        "CP_C_SHOP_ECODE":"YZ001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁旗舰店-微店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":70,
                        "CP_C_SHOP_ECODE":"hao12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hao测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":37,
                        "CP_C_SHOP_ECODE":"TM-VS",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"吉列官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":69,
                        "CP_C_SHOP_ECODE":"a00001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":87,
                        "CP_C_SHOP_ECODE":"AX001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"翱象联调测试账号6",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":2,
                        "CP_C_SHOP_ECODE":"TM-PG",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"拦截欠件",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":84,
                        "CP_C_SHOP_ECODE":"CS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    }
                ]
            }
        ],
        "count":0.0000,
        "title":"拦截欠件",
        "key":"INTERCEPTION_ORDER"
    },
    "deliveredNotCompleted":{
        "data":[
            {
                "shopList":[
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":87,
                        "CP_C_SHOP_ECODE":"AX001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"翱象联调测试账号6",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":71,
                        "CP_C_SHOP_ECODE":"you12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"haoyouzan",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":49,
                        "CP_C_SHOP_ECODE":"ggggggg",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"fdgrgre",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":84,
                        "CP_C_SHOP_ECODE":"CS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":44,
                        "CP_C_SHOP_ECODE":"fyt",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"哈哈哈哈哈",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":37,
                        "CP_C_SHOP_ECODE":"TM-VS",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"吉列官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":19,
                        "CP_C_SHOP_ECODE":"11 1122啊啊啊",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":50,
                        "CP_C_SHOP_ECODE":"878888887WUWUUWU",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"大概",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":75,
                        "CP_C_SHOP_ECODE":"BB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"xxmtest",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":85,
                        "CP_C_SHOP_ECODE":"CS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":33,
                        "CP_C_SHOP_ECODE":"1004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号177",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":73,
                        "CP_C_SHOP_ECODE":"AAA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":31,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"olay官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":21,
                        "CP_C_SHOP_ECODE":"123",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"沙宣官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":60,
                        "CP_C_SHOP_ECODE":"1002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"店铺测试001",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":62,
                        "CP_C_SHOP_ECODE":"1111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试11111111",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":61,
                        "CP_C_SHOP_ECODE":"100 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺002",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":74,
                        "CP_C_SHOP_ECODE":"ABC",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺zxs",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":39,
                        "CP_C_SHOP_ECODE":"aabb",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号278",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":43,
                        "CP_C_SHOP_ECODE":"XHS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小红书宝洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":63,
                        "CP_C_SHOP_ECODE":"AAT001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺-自动化专用（勿动）",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":80,
                        "CP_C_SHOP_ECODE":"lyh平台店铺",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"lyh平台店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":69,
                        "CP_C_SHOP_ECODE":"a00001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":51,
                        "CP_C_SHOP_ECODE":"110",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":36,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"欧乐b一商益洁专卖店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":66,
                        "CP_C_SHOP_ECODE":"1 004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺3小小王测试店铺3小王测试店铺3小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":83,
                        "CP_C_SHOP_ECODE":"2323",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":86,
                        "CP_C_SHOP_ECODE":"123131",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"张测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":65,
                        "CP_C_SHOP_ECODE":"10 0 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":79,
                        "CP_C_SHOP_ECODE":"POP-DB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP-抖音宝洁小铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":23,
                        "CP_C_SHOP_ECODE":"12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aussie旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":40,
                        "CP_C_SHOP_ECODE":"gjdp",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"古古店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":77,
                        "CP_C_SHOP_ECODE":"11",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"SK-II官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":56,
                        "CP_C_SHOP_ECODE":"YZ-EP",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"EAZYPEY有赞",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":41,
                        "CP_C_SHOP_ECODE":"XHS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP小红书-植感哲学",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":81,
                        "CP_C_SHOP_ECODE":"cl10101",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁洗护清洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":68,
                        "CP_C_SHOP_ECODE":"1005",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":22,
                        "CP_C_SHOP_ECODE":"1234",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁集市自营店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":76,
                        "CP_C_SHOP_ECODE":"cc",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"cc",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":64,
                        "CP_C_SHOP_ECODE":"2021014",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"2021014",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":88,
                        "CP_C_SHOP_ECODE":"111212",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"11",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":59,
                        "CP_C_SHOP_ECODE":"YZ-EP1",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":46,
                        "CP_C_SHOP_ECODE":"111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试hold单权限",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":78,
                        "CP_C_SHOP_ECODE":"JDMARNA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"MARNA京东旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":67,
                        "CP_C_SHOP_ECODE":"aaaaaaaa",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":70,
                        "CP_C_SHOP_ECODE":"hao12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hao测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":20,
                        "CP_C_SHOP_ECODE":"bbs001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"帮宝适官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":52,
                        "CP_C_SHOP_ECODE":"221",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":42,
                        "CP_C_SHOP_ECODE":"YZ001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁旗舰店-微店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":55,
                        "CP_C_SHOP_ECODE":"2021",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":82,
                        "CP_C_SHOP_ECODE":"sss0001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁生活馆",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":35,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"HerbalEssences官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":2,
                        "CP_C_SHOP_ECODE":"TM-PG",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":32,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":24,
                        "CP_C_SHOP_ECODE":"1234567",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hairrecipe官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":48,
                        "CP_C_SHOP_ECODE":"qqqqq",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"业务讲解店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":38,
                        "CP_C_SHOP_ECODE":"XXKH",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"线下客户",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":47,
                        "CP_C_SHOP_ECODE":"11222",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hold单测试11.12",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":72,
                        "CP_C_SHOP_ECODE":"BM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"布美",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"已发货未完结",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":45,
                        "CP_C_SHOP_ECODE":"1 00 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"款到货未到",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    }
                ],
                "count":0.0000,
                "title":"款到货未到",
                "key":"GOODS_NOT_ARRIVED"
            }
        ],
        "count":0.0000,
        "title":"已发货未完结",
        "key":"DELIVERED_NOT_COMPLETED"
    },
    "orderConversionFailed":{
        "data":[
            {
                "shopList":[
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":65,
                        "CP_C_SHOP_ECODE":"10 0 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":69,
                        "CP_C_SHOP_ECODE":"a00001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":35,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"HerbalEssences官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":73,
                        "CP_C_SHOP_ECODE":"AAA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":37,
                        "CP_C_SHOP_ECODE":"TM-VS",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"吉列官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":46,
                        "CP_C_SHOP_ECODE":"111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试hold单权限",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":68,
                        "CP_C_SHOP_ECODE":"1005",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"姜宇测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":0,
                        "CP_C_SHOP_ECODE":null,
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":null,
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":55,
                        "CP_C_SHOP_ECODE":"2021",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":44,
                        "CP_C_SHOP_ECODE":"fyt",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"哈哈哈哈哈",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":67,
                        "CP_C_SHOP_ECODE":"aaaaaaaa",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":72,
                        "CP_C_SHOP_ECODE":"BM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"布美",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":45,
                        "CP_C_SHOP_ECODE":"1 00 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":51,
                        "CP_C_SHOP_ECODE":"110",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":20,
                        "CP_C_SHOP_ECODE":"bbs001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"帮宝适官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":85,
                        "CP_C_SHOP_ECODE":"CS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺2",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":76,
                        "CP_C_SHOP_ECODE":"cc",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"cc",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":87,
                        "CP_C_SHOP_ECODE":"AX001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"翱象联调测试账号6",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":71,
                        "CP_C_SHOP_ECODE":"you12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"haoyouzan",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":86,
                        "CP_C_SHOP_ECODE":"123131",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"张测试",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":56,
                        "CP_C_SHOP_ECODE":"YZ-EP",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"EAZYPEY有赞",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":39,
                        "CP_C_SHOP_ECODE":"aabb",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号278",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":75,
                        "CP_C_SHOP_ECODE":"BB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"xxmtest",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":78,
                        "CP_C_SHOP_ECODE":"JDMARNA",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"MARNA京东旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":1,
                        "CP_C_SHOP_ECODE":null,
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":null,
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":42,
                        "CP_C_SHOP_ECODE":"YZ001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁旗舰店-微店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":88,
                        "CP_C_SHOP_ECODE":"111212",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"11",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":63,
                        "CP_C_SHOP_ECODE":"AAT001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺-自动化专用（勿动）",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":59,
                        "CP_C_SHOP_ECODE":"YZ-EP1",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"1",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":41,
                        "CP_C_SHOP_ECODE":"XHS002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP小红书-植感哲学",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":36,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"欧乐b一商益洁专卖店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":19,
                        "CP_C_SHOP_ECODE":"11 1122啊啊啊",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":82,
                        "CP_C_SHOP_ECODE":"sss0001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁生活馆",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":50,
                        "CP_C_SHOP_ECODE":"878888887WUWUUWU",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"大概",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":83,
                        "CP_C_SHOP_ECODE":"2323",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":74,
                        "CP_C_SHOP_ECODE":"ABC",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺zxs",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":81,
                        "CP_C_SHOP_ECODE":"cl10101",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁洗护清洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":80,
                        "CP_C_SHOP_ECODE":"lyh平台店铺",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"lyh平台店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":24,
                        "CP_C_SHOP_ECODE":"1234567",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hairrecipe官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":2,
                        "CP_C_SHOP_ECODE":"TM-PG",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":62,
                        "CP_C_SHOP_ECODE":"1111",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试11111111",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":32,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"First Aid Beauty官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":66,
                        "CP_C_SHOP_ECODE":"1 004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小王测试店铺3小小王测试店铺3小王测试店铺3小王测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":22,
                        "CP_C_SHOP_ECODE":"1234",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁集市自营店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":77,
                        "CP_C_SHOP_ECODE":"11",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"SK-II官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":47,
                        "CP_C_SHOP_ECODE":"11222",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hold单测试11.12",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":21,
                        "CP_C_SHOP_ECODE":"123",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"沙宣官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":70,
                        "CP_C_SHOP_ECODE":"hao12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"hao测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":60,
                        "CP_C_SHOP_ECODE":"1002",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"店铺测试001",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":38,
                        "CP_C_SHOP_ECODE":"XXKH",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"线下客户",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":31,
                        "CP_C_SHOP_ECODE":"TM",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"olay官方旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":49,
                        "CP_C_SHOP_ECODE":"ggggggg",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"fdgrgre",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":40,
                        "CP_C_SHOP_ECODE":"gjdp",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"古古店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":79,
                        "CP_C_SHOP_ECODE":"POP-DB",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"POP-抖音宝洁小铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":48,
                        "CP_C_SHOP_ECODE":"qqqqq",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"业务讲解店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":33,
                        "CP_C_SHOP_ECODE":"1004",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"b商家测试帐号177",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":43,
                        "CP_C_SHOP_ECODE":"XHS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"小红书宝洁旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":64,
                        "CP_C_SHOP_ECODE":"2021014",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"2021014",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":52,
                        "CP_C_SHOP_ECODE":"221",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"宝洁",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":23,
                        "CP_C_SHOP_ECODE":"12345",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"aussie旗舰店",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":84,
                        "CP_C_SHOP_ECODE":"CS001",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"CS测试店铺",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    },
                    {
                        "rpt_type":"订单转换失败",
                        "CREATIONDATE":null,
                        "OWNERID":null,
                        "rpt_type_sub_2":null,
                        "MODIFIERNAME":null,
                        "AD_CLIENT_ID":null,
                        "AD_ORG_ID":null,
                        "CP_C_SHOP_ID":61,
                        "CP_C_SHOP_ECODE":"100 4",
                        "MODIFIEDDATE":null,
                        "SHOP_ENAME":"测试店铺002",
                        "CP_C_STORE_ID":null,
                        "ISACTIVE":null,
                        "OWNERNAME":null,
                        "rpt_type_sub":"SKU异常",
                        "duration":"today",
                        "rpt_value":0.0000,
                        "MODIFIERID":null,
                        "ID":null,
                        "updated":1676361672000
                    }
                ],
                "count":0.0000,
                "title":"SKU异常",
                "key":"SKU_ABNORMAL"
            }
        ],
        "count":0.0000,
        "title":"订单转换失败",
        "key":"ORDER_CONVERSION_FAILED"
    }
}